import { PlatformLayout } from "./platform-layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EnhancementsContent } from "./platform-enhancements";
import { FeedbackContent } from "./platform-feedback";
import { GlobalLeadGenSettingsContent } from "./platform-lead-gen-settings";
import { Sparkles, MessageSquare, Search } from "lucide-react";

export function ConfigHubContent() {
  return (
    <Tabs defaultValue="enhancements">
      <TabsList className="flex flex-wrap h-auto gap-1 mb-4">
        <TabsTrigger value="enhancements" data-testid="tab-config-enhancements">
          <Sparkles className="h-4 w-4 mr-1.5" />
          Enhancements
        </TabsTrigger>
        <TabsTrigger value="feedback" data-testid="tab-config-feedback">
          <MessageSquare className="h-4 w-4 mr-1.5" />
          Feedback
        </TabsTrigger>
        <TabsTrigger value="ai-lead-search" data-testid="tab-config-ai-lead-search">
          <Search className="h-4 w-4 mr-1.5" />
          AI Lead Search
        </TabsTrigger>
      </TabsList>

      <TabsContent value="enhancements">
        <EnhancementsContent />
      </TabsContent>
      <TabsContent value="feedback">
        <FeedbackContent />
      </TabsContent>
      <TabsContent value="ai-lead-search">
        <GlobalLeadGenSettingsContent />
      </TabsContent>
    </Tabs>
  );
}

export default function PlatformConfigHub() {
  return (
    <PlatformLayout>
      <ConfigHubContent />
    </PlatformLayout>
  );
}
